<template>
  <div class="bggray" @click="optionActive = false">
    <app-header />
    <div class="orderWrap">
      <div class="orderNav">
        <span class="cur">确认购买信息</span>
        <span>选择支付方式</span>
        <span>购买成功开通权限</span>
      </div>
      <div class="mod orderInfo">
        <h3 class="title">订单详情<span>{{remark}}</span></h3>
        <ul class="column6">
          <li class="title">
            <div class="liwrap">
              <div>产品名称</div>
              <div>价格/年限</div>
              <div class="child3">数量</div>
              <div class="child4">有效期</div>
              <div class="child5">优惠</div>
              <div class="child6">实付</div>
            </div>
          </li>
          <li class="mainli clearfix">
            <div class="liwrap">
              <div>
                <p>{{ product.name }}</p>
                <p class="giftName" v-show="productId !== null">{{ product.describe }}</p>
              </div>
              <div class="select">
                <el-select v-model="month" placeholder="请选择" style="width:150px">
                  <el-option
                    v-for="item in product.productPriceVos"
                    :key="item.month"
                    :label="item.oriPrice | amountUnitFormat(item.month)"
                    :value="item.month"
                  ></el-option>
                </el-select>
              </div>
              <div class="child3">*{{month}}个月</div>
              <div
                v-for="item in product.productPriceVos"
                :key="item.month"
                v-show="item.month === month"
                class="child4"
              >{{item.powerStartDt | dateFormat("yyyy-MM-dd")}}至{{ isZQ?(productSentPowerTime(item.powerEndDt,foldedPeriod)): (item.powerEndDt) | dateFormat("yyyy-MM-dd")}}
              </div>
              <div class="child5" v-show="!product.multipleSubtotalPrompt">¥ {{mainCurPrice | twinPointAmountFormat(mainOriPrice)}}</div>
              <div class="child5" v-show="product.multipleSubtotalPrompt">/</div>
              <div class="child6">¥ {{mainCurPrice}}</div>
            </div>
            <div class="licheckbox">
              <!-- 折期 -->
               <div class="licheckbox" style="line-height: 2;">
                <span @click="isZQ=!isZQ;isCE=!isCE;showCE=false" v-show="foldedPeriod && foldedPeriod >0" class="licheckbox-label" :class="isZQ?'selected':''">我同意将现有大智慧低版本剩余期限按实际价值折算，合计{{foldedPeriod}}天累加至新产品有效期内</span><a class="licheckbox-btn-more" @click="isZQ?showZQ=!showZQ:''" v-show="foldedPeriod && foldedPeriod >0 && isZQ">{{showZQ&&isZQ?'收起明细':'展开明细'}}</a>
              </div>
              <!-- 补差 -->
              <div class="licheckbox">
                <span @click="isCE=!isCE;isZQ=!isZQ;showZQ=false" v-show="foldedPeriod && foldedPeriod >0" class="licheckbox-label" :class="isCE?'selected':''">我同意将现有大智慧低版本剩余期限按实际价值折算后进行补差升级</span><a class="licheckbox-btn-more" @click="isCE?showCE=!showCE:''" v-show="foldedPeriod && foldedPeriod >0 && isCE">{{showCE&&isCE?'收起明细':'展开明细'}}</a>
              </div>
              <!-- 权限并行明细 -->
              <!-- 低买高 -->
              <div class="qxWarning" id="qxWarning" :class="{'qxOK':isZQ}" v-show="showZQ&&isZQ">
                <h5>【温馨提示】</h5>
                <p>为了购买新版本的大智慧，您需要将现有低版本大智慧的剩余期限按实际价值进行折算，并累计至新产品的有效期中。现有产品如下：</p>
                <ul>
                  <div
                    v-for="item in discountList"
                    :key="item.productId"
                  >
                    <li>{{ item.productName }} <span class="fr">+{{item.foldPeriodDayLength}}天</span></li>
                  </div>  
                  <li class="total">合计可折期限 <span class="fr">当前购买产品&nbsp;&nbsp;&nbsp;&nbsp;+{{foldedPeriod}}天</span></li>
                </ul>
              </div>
            </div>
          </li>
          <template v-for="item in product.productPriceVos" >
            <li :key="item.month" v-show="item.month === month && item.subProductPriceVos" class="subli">
              <div v-for="subItem in item.subProductPriceVos" :key="subItem.month" class="liwrap">
                <div>{{subItem.productName}}</div>
                <div>{{subItem.oriPrice | amountUnitFormat(subItem.month)}}</div>
                <div class="child3">*{{subItem.month}}个月</div>
                <div class="child4">{{subItem.powerStartDt | dateFormat("yyyy-MM-dd")}}至{{subItem.powerEndDt | dateFormat("yyyy-MM-dd")}}</div>
                <div class="child5">¥ {{subItem.curPrice | amountUnitFormat(subItem.oriPrice)}}</div>
                <div class="child6">¥ {{subItem.curPrice}}</div>
              </div>
            </li>
          </template>
        </ul>
        <div class="totalLine">
          <p class="note" v-show="yjtText">*该月卡为特惠体验产品，仅可购买一次，且不支持折换等其他优惠活动，敬请谅解</p>
          <p class="note" v-if="productId == 3052 || productId == 3053">*到期前续费该PC产品可享受老客户优惠，不与其他活动叠加享受，题材王为手机版功能不参与老用户续费优惠</p>
          <p class="note" v-else-if="productId == 3047 || productId == 3048 || productId == 3049 || productId == 3050">*到期前续费该PC产品可享受老客户优惠，不与其他活动叠加享受，沪深level2手机版不参与老用户续费优惠</p>
          <p class="note" v-else-if="productId == 3028 || productId == 3041 || productId == 3042 || productId == 3046">*本产品中的移动指标将单独计算使用期限，已经购买过移动相关指标的客户不可与本礼包中包含的移动指标叠加使用</p>
          <p class="note" v-else-if="oyb">*每个大智慧账号、每个支付账号，限购买一次；同支付账号购买多次，第二次起软件使用时长为7天</p>
          <p class="note" v-else-if="!(productId == 335 || productId == 197 || productId == 2022)">*到期前续费该产品可享受老客户优惠，不与其他活动叠加享受</p>
          <p class="voucherText" v-show="voucherCode!=0">*{{voucherMsg}}</p>

          <div>
            <div class="discount-select" v-show="showCE">
              <div class="discount-text">
                <p v-for="item in discountList" :key="item.productId"><strong>您的《{{item.productName}}》剩余期限{{item.remainLength}}天，价值{{item.convertMoney}}元。</strong><em>¥ -{{item.convertMoney}}</em><em>¥ -{{item.convertMoney}}</em></p>
              </div>
            </div>
          </div>

          <!-- 高买低 -->
          <div class="qxWarning qxAlert" v-show="showQXNOCan">
            <p><strong>系统检测到您已拥有其他版本大智慧，本产品不可购买，如有疑问可联系客服。</strong></p>
          </div>
          <!-- 高买低暂存 -->
          <div class="qxWarning qxAlert" v-show="showQXCan">
            <p><strong>系统检测到您已拥有其他版本大智慧，如继续购买该产品将优先消耗高版本大智慧产品，该产品有效期将为您预存在“我的产品”中。</strong></p>
          </div>

          <div class="subtotal" v-show="!product.multipleSubtotalPrompt">
            <div>小计</div>
            <div>共{{productNum}}件</div>
            <div>¥ {{mainCurPrice | getDisCountMoney(mainOriPrice,subCurPrice,subOriPrice,convertMoneyEnd)}}</div>
            <div>¥ {{ mainCurPrice | getPayMoneyTotal(subCurPrice,convertMoneyEnd) }}</div>
          </div>
          <div class="subtotal" v-show="product.multipleSubtotalPrompt">
            <div style="width: 90px;">小计</div>
            <div style="width: 590px;text-align: left; font-size: 12px;">{{product.multipleSubtotalPrompt}}</div>
            <div style="width: 129px;text-align: left;">优惠{{mainCurPrice | twinPointAmountFormat(mainOriPrice)}}</div>
            <div style="width: 90px;text-align: left;">¥ {{ mainCurPrice | getPayMoneyTotal(subCurPrice,convertMoneyEnd) }}</div>
          </div>
          <p class="hknote" v-show="productId == 2022">注：该产品仅限中国大陆用户使用，境外IP不可使用</p>
          <div class="discount-money">

            <div class="note-r">
              <p>
                <span>{{this.discountIndex === 1 ? '已折算：' : '已优惠：'}}</span>
                <em
                  v-for="item in product.productPriceVos"
                  :key="item.month"
                  v-show="item.month === month"
                >{{mainCurPrice | getDisCountMoney(mainOriPrice,subCurPrice,subOriPrice,convertMoneyEnd)}} 元</em>
              </p>
              <p class="totalMoney">
                <span>支付金额总计：</span>
                <strong
                  v-for="item in product.productPriceVos"
                  :key="item.month"
                  v-show="item.month === month"
                >{{ mainCurPrice | getPayMoneyTotal(subCurPrice,convertMoneyEnd)}}</strong>
                <em>元</em>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 购买协议组件 -->
      <div class="license">
        <h3 class="title">
          <span class="agreement">
            <router-link to="/protocol" target="_blank">使用软件产品许可协议</router-link>
          </span>
          <p>
            <i
              class="icon-right"
              @click="cancelActive = !cancelActive"
              :class="{cancel:cancelActive}"
            ></i>我已仔细阅读相关协议，对其内容表示确认
          </p>
        </h3>
      </div>
      
      <!-- v-if="productId == 126 || productId == 197 || productId == 113 || productId == 335 || productId == 350 " -->
      <div class="questionnaire" v-if="productId == 126 || productId == 197 || productId == 113 || productId == 335 || productId == 350 ">
        <a class="fr r-btn-edit" :class="isSubmit?'actived':''" @click="showQAPop=true">{{isSubmit?'已填写':'填写问卷'}}</a>
        <p><strong>风险测评问卷<em>(必填)</em></strong>根据相关合规要求，本次产品购买需先进行风险测评。</p>
      </div>

      <div class="mod invoice">
        <h3 class="title">发票信息</h3>
        <p>
          <strong>
            <span>电子普通发票</span>
            <span v-show="invoiceTitleType == 1">个人</span>
            <span v-show="invoiceTitleType == 2">单位</span>
            <span>信息技术服务</span>
          </strong>
          <em class="modify" @click="openInvoice">发票填开</em>
        </p>
        <a class="confirmBtn" @click="orderConfirm" :class="{'disabled':! showOrderButten}">确认订单</a>
        <!-- 电子发票组件 -->
        <invoice @changeInvoiceTitleType="changeInvoiceTitleType" ref="invoice" />
      </div>
    </div>
    <app-footer />
    <bind-tel :info="info" v-show="isPop" @close="popColse"></bind-tel>

    <!-- 风险测评弹框 -->
    <div class="pop" v-show="showQAPop">
      <div class="pop-win-qa">
        <div class="pop-win-qa-head">
          根据相关合规要求，本次产品购买需先进行风险测评。
          <span class="r-btn-close" @click="showQAPop=false">x</span>
        </div>
        <div class="pop-win-qa-cont">
          <ul class="qa-list">
            <li v-for="item in qaList" :key="item.id">
              <h5>{{item.sort}}、{{item.title}}</h5>
              <div class="anwser-wrap">
              <p v-for="(ans,i) in item.answers" @click="selectAnswer(item,i)" :class="item.curAnswer==i?'actived':''" :key="ans.id"><a><!--<em>{{ans.sort|formateAnswerIndex}}</em>. -->{{ans.title}}</a></p>
              </div>
              <div class="edit-bar" v-show="item.sort===2&&item.curAnswer==1"><input type="text" v-model="item.extraInfo" placeholder="请填写您与实际购买人的关系"/></div>
              <p class="link-bar" v-show="item.sort===3&&item.curAnswer==1"><a @click="showRiskPop=true">查看风险提示，请点击此处</a></p>
              <p class="link-bar" v-show="item.sort===4&&item.curAnswer==1"><a target="_blank" :href="productId == 335||productId == 350?'https://help335.dzh.com.cn/help123/':'http://help123.dzh.com.cn/help123/'">了解大智慧软件产品信息，请点击此处</a></p>
            </li>
          </ul>
        </div>
        <div class="pop-win-qa-foot">
          <p class="risk" v-if="showQAError">您尚有问题没有回答，请全部答完再提交！</p>
          <a class="pop-btn-block" :class="selectNum>=5?'':'disabled'" @click="submitFun()">提交测评</a>
        </div>
        <div class="pop-notice" v-show="showNotice">
          <div class="pop-notice-win">
            <p>您当前购买的是{{ product.name }}产品!<br/>原价{{ this.mainOriPrice}}{{ this.productAttachTimeUnit(this.month) }}</p>
            <a class="pop-btn-block" @click="showNotice=false;qaList[4].curAnswer=0">我已知晓</a>
          </div>          
        </div>
        <div class="pop-rules" v-show="showRulePop">
          <div class="pop-rules-return"><a class="fl" @click="showRulePop=false">返回</a></div>
          <h6>您是否确认继续购买当前产品，请签订风险知情书</h6>
          <div class="pop-rules-cont">
            <strong>尊敬的客户：</strong>
            <p>在您选择购买并使用大智慧证券信息服务软件前，我们有责任向您介绍产品属性、风险等相关信息，以确保您能做出明智的决策。 在此，特别提醒各位<strong>高龄投资者</strong>，若您坚持购买证券行情信息软件，请务必在购买开通各项业务权限前全面了解证券法律法规、监管规定、证券交易所的交易规则和业务规则，对自身的行为能力、身心承受能力、资金承受能力、风险承受能力及控制能力等做出全面、客观、审慎地判断，并在账户及相关账户权限开通后予以持续关注，确认自己具有完全民事行为能力并能够自行承担一切交易结果。</p>
            <strong>一、产品属性告知</strong>
            <p>1.大智慧证券信息服务软件提供证券市场的实时行情和资讯，帮助投资者更好地了解市场动态。然而，它并不能保证投资收益，也无法消除投资风险。</p>
            <p>2.请知晓大智慧不提供任何形式的荐股服务，如有疑问请及时向大智慧反馈。</p>
            <strong>二、风险提示</strong>
            <p>1.市场风险：证券市场受许多因素影响，包括但不限于全球和国内经济状况、政策变动、公司经营状况等。这些因素可能导致证券价格波动，从而影响您的投资收益。</p>
            <p>2.信息风险：虽然我们尽力提供准确、及时的信息，但不能保证信息的完全准确性和及时性。本公司所有提供的数据和信息仅供用户参考，不构成用户进行投资操作的直接依据。用户根据此操作需自行承担风险，公司不承担任何经济和法律责任。</p>
            <p>3.操作风险：由于您的年龄原因，操作电子设备或理解复杂的投资信息可能会有一定难度。建议您在使用软件或进行投资操作前寻求专业人士的帮助。</p>
            <p>综上所述，投资有风险，入市需谨慎。我们建议您在使用软件或参与证券投资前，充分了解投资风险，明确自身的风险承受能力，投资金额不宜超出可承受的损失范围。同时，应根据自身的投资目标、投资期限、风险承受能力等因素，合理配置资产。</p>
            <p>请您在阅读和理解以上内容后，自行决定是否购买和使用大智慧证券信息服务软件，以及是否参与证券投资并能够自行承担一切结果。</p>
            <p>谢谢您的理解与支持！</p>
          </div>
          <a class="pop-win-link" @click="confirmRuleFun(1)">我已知晓，开始购买<i></i></a>
        </div>
        <div class="pop-rules" v-show="showRiskPop">
          <div class="pop-rules-return"><a class="fl" @click="showRiskPop=false">返回</a></div>
          <h6>风险提示</h6>
          <div class="pop-rules-cont">
            <p>1、用户应充分认识到证券投资的风险。公司所提供的所有数据与信息，仅供用户参考使用，不构成用户进行投资操作的直接依据，用户据此操作，风险自担，公司不承担任何经济与法律责任。</p>
            <p>2、公司通过软件产品为用户提供财经金融资讯和行情数据信息，并通过相关数据分析系统、同级运算模型对上述资讯和数据进行整理、加工和集成，为用户提供高附加值的信息和数据服务，以利于用户在投资过程中理性决策、控制风险。用户在使用软件产品过程中，对于公司提供的数据信息内容，用户不应将其视作公司明示、默示的承诺证券、期货的投资收益，不应将其视为具体证券品种选择/买卖时机的建议，或任何其他形式的证券投资咨询/建议。公司对用户的投资决策可能带来的风险或损失不承担任何违约、赔偿或其他民事责任。</p>
            <p>3、证券市场具有较大的风险，请您注意。</p>
            <p>4、本公司相关服务及产品仅是投资辅助工具，单一业绩不代表全面业绩、过往业绩不代表将来业绩，无法保证投资不受损失。</p>
            <p>5、本公司禁止对服务能力和过往业绩进行虚假、不实、误导性的营销宣传，禁止以任何方式承诺或保证投资收益。</p>
            <p>6、本公司不提供代客理财、证券投资咨询服务。</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 权限并行提示弹框 -->
    <div class="pop" v-show="showQXConfirm">
      <div class="pop-win-confirm">
        <span class="pop-close" @click="showQXConfirm=false"></span>
        <h6>提示</h6>
        <p>您需要先同意，将现有低版本大智慧剩余期限按实际价值进行折期或折价才可购买新版本大智慧。</p>
        <div class="pop-win-btns flex">
          <a href="javascript:;" @click="showQXConfirm=false">取消</a>
          <a href="javascript:;" class="btn-ok" @click="showQXConfirm=false;">同意</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
import AppFooter from "@/components/common/AppFooter.vue";
import Protocol from "@/components/protocol/Protocol.vue";
import Invoice from "@/components/invoice/Invoice.vue";
// import PayFinsh from '../client/PayFinsh.vue';
import BindTel from '@/components/product/BindTel.vue'

export default {
  data() {
    return {
      product: {},
      productId: this.$route.params.productId,
      month: "",
      cancelActive: false,
      invoiceTitleType: 1,
      discountList: [],
      foldedPeriod: 0,
      discountText: false,
      convertMoney: 0,
      remark:'',
      voucherCode:0,
      voucherMsg:"",
      info: {
        isWait: true,
        isBind: true,
        bindUrl: ''
      },
      isPop: false,
      isShowMore: false,
      discountIndex:2,
      oyb: false,
      yjtText: false,
      isSubmit:false,
      showQAPop:false,
      qaList:[],
      relationName:'',
      showNotice:false,
      selectNum:0,
      showQAError:false,
      showRulePop:false,
      isConfirmRules:false,
      //qaRules:[],
      questionnaireData:'',
      showRiskPop:false,
      mainCurPrice: 0,
      mainOriPrice: 0,
      s: this.$route.query.s,
      showZQ: false,
      showCE: false,
      showQXCan:false,
      showQXNOCan:false,
      isZQ:true,
      isCE: false,
      //isAlert:true,
      showQXConfirm:false,
      showOrderButten:true,
    };
  },
  created() {
    document.title="大智慧股票软件网上商城"
    var month = this.$route.params.month;
    if (month) {
      if(month == '1dzhpfo'){
        this.month = 1;
      }else if(month == '1'){
        this.month = 12;
      }else{
        this.month = Number(month);
      }
    }
    this.getProduct();
    this.getQAData();
  },
  mounted() {
    this.invoiceTitleType = this.$refs.invoice.invoiceTitleType;    
  },
  filters:{
    formateAnswerIndex:function(v){
      if(v==1) return 'A'
      if(v==2) return 'B'
      if(v==3) return 'C'
      if(v==4) return 'D'
    }
  },
  computed: {
    curPrice() {
      this.product.productPriceVos.forEach(item => {
        if (item.month == this.month) {
          return item.curPrice;
        }
      });
    },
    oriPrice() {
      this.product.productPriceVos.forEach(item => {
        if (item.month == this.month) {
          return item.oriPrice;
        }
      });
    },
    activityType() {
      let type = '' ;
      this.product.productPriceVos.forEach(item =>{
        if(item.month == this.month) {
           type= item.activityType
        }
      })
      return type;
    },
    convertMoneyEnd () {
      return this.isCE? this.convertMoney : 0
    },
    orderType () {
      return this.foldedPeriod && this.foldedPeriod > 0 ? 2 : 0
    }
  },
  watch: {
    month () {
      if (this.product.productPriceVos) {
        this.getPrice()
        this.qaListTheLastOne()
        this.selectFoldedPeriod()
      }
    }
  },
  methods: {
    getProduct() {
      var params = {
        id: this.productId
      };
      if (this.month) {
        params.month = this.month
      }
      this.$get("/product/detail", params)
        .then(response => {
          if (response.code === 0) {
            this.product = response.data;
            if(response.data.month === 1 && (this.productId == 116 || this.productId == 338)){
              this.oyb = true;
            }
            var prices = this.product.productPriceVos;
            this.getPrice()
            var flag = false;
            if (this.month) {
              prices.forEach((item, index) => {
                if(item.defaultShow && item.defaultShow === 1){
                    this.month = item.month
                }
                if (item.month == this.month) {
                  flag = true;
                  if(item.remark){this.remark = item.remark}
                }
              });
              if (!flag) {
                this.month = prices[0].month;
              }
            } else {
              this.month = prices[0].month;
            }
            params.month = this.month;
            this.$get("/order/orderUpgradeCalc", params)
              .then(response => {
                if (response.code === 0) {
                  var checkCode = response.data.powerCheckCode
                  if(checkCode == 1 || checkCode == 12 || checkCode == 2 || checkCode == 0){
                    if(checkCode == 12 || checkCode == 2){
                      this.showQXCan = true;
                    }
                    this.discountList = response.data.orderVoucherGroupVoList;
                    this.foldedPeriod = response.data.foldedPeriod;
                    if(this.discountList!=null){
                      this.foldedPeriod = response.data.foldedPeriod;
                      this.discountList.length > 0 && (this.discountText = true);
                      this.convertMoney = this.discountList.reduce((pre, cur) =>{
                      return pre + cur.convertMoney
                      }, 0)
                    }
                  }else if(checkCode == 3){
                    this.showQXNOCan = true;
                    this.showOrderButten = false;
                  }
                } else {
                  this.voucherCode = response.code;
                  this.voucherMsg = response.msg
                  return
                }
              })
          }else if(response.code === 107){
            this.$global.alertAndGoHistory(response.msg)
          }
           else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    selectFoldedPeriod(){
      var params = {
        id: this.productId,
        month: this.month
      };
      this.$get("/order/orderUpgradeCalc", params)
              .then(response => {
                if (response.code === 0) {
                  this.discountList = response.data.orderVoucherGroupVoList;
                  this.foldedPeriod = response.data.foldedPeriod;
                  this.discountList.length > 0 && (this.discountText = true);
                  this.convertMoney = this.discountList.reduce((pre, cur) =>{
                    return pre + cur.convertMoney
                  }, 0)
                } else {
                  this.voucherCode = response.code;
                  this.voucherMsg = response.msg
                  return
                }
              })
    },
    openInvoice() {
      //调用子组件发票抬头类型
      this.$refs.invoice.openInvoice();
    },
    changeInvoiceTitleType(invoiceTitleType) {
      //获取发票组件发票抬头类型
      this.invoiceTitleType = invoiceTitleType;
    },
    orderConfirm() {
      if(this.foldedPeriod > 0 && !this.isZQ && !this.isCE){
        //this.isAlert = true
        this.showQXConfirm = true
        window.scrollTo({
          top: document.getElementById('qxWarning').offsetTop-100,
        })
        return false;
      }
      if(!this.showOrderButten){
        window.scrollTo({
          top: document.getElementById('qxWarning').offsetTop-100,
        })
        return false;
      };
      if (this.cancelActive) {
        this.$alert(
          "请仔细阅读“上海大智慧信息科技有限公司软件产品许可使用协议”，阅读结束后同意请选中“我同意协议”钩选框，然后继续购买。",
          "提示",
          {
            confirmButtonText: "确定"
          }
        );
        return false;
      }

      // 保存订单并跳转到支付页面
      var params = {
        productId: this.productId,
        monthCount: this.month,
        invoiceTitleType: this.invoiceTitleType,
        convertMoney: this.convertMoneyEnd,
        activityType: this.activityType,
        questionsId: this.questionnaireData,
        foldedPeriodDayNum: this.foldedPeriod,
        buySource: this.s
      };
      params.orderType = 0
      if(this.foldedPeriod > 0){
        if (this.isZQ) {
          params.orderType = 2
        }
        if(this.isCE){
          params.orderType = 1
        }
      }
      if (Number(this.productId) === 335 || Number(this.productId) === 350) {
        this.isPop = true
        this.$get("user/checkMobile?"+"productId="+this.productId).then(res =>{
          if(res.code === 0) {
            this.isPop = false
            this.$post("/order/save", params)
            .then(response => {
              if (response.code === 0) {
                this.$router.push("/order/pay/" + response.data.id);
              } else if (response.code === 401) {
                //this.$global.alert(response.msg);
                this.showQAPop=true
              }else if(response.code != 100){
                this.$global.alert(response.msg);
              }
            })
            .catch(err => {
              this.$global.alertError();
            });
          } else if(res.code === 107) {
            this.info.isWait = false
            this.info.isBind = false
            this.info.bindUrl = res.msg
          } else{
              this.$global.alert(res.msg);
            }
        }).catch(err => {
          this.$global.alertError();
        });
      } else {
        this.$post("/order/save", params)
        .then(response => {
          console.log(response)
          if (response.code === 0) {
            this.$router.push("/order/pay/" + response.data.id);
          } else if (response.code === 401) {
            //this.$global.alert(response.msg);
            this.showQAPop=true
          }else{
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
      }
    },
    changeSelect (i) {
      this.curIndex = i
    },
    getPrice () {
      this.product.productPriceVos.forEach(item => {
        if (item.month == this.month) {
          this.mainCurPrice = item.curPrice;
          this.mainOriPrice = item.oriPrice
          if (item.hasOwnProperty("subProductPriceVos")) {
            this.subCurPrice = item.subProductPriceVos.reduce((pre, cur) =>{
              return pre + cur.curPrice
            }, 0)
            this.subOriPrice = item.subProductPriceVos.reduce((pre, cur) =>{
              return pre + cur.oriPrice
            }, 0)
            this.productNum = 1 + item.subProductPriceVos.length
          } else {
            this.subCurPrice = 0
            this.subOriPrice = 0
            this.productNum = 1
          }
        }
      })
      if(this.productId === '335' && (this.month === 1 || this.month === 7 || this.month === 14)){
          this.yjtText = true;
      }else{
        this.yjtText = false;
      }
    },
    popColse (val) {
      this.isPop = val
    },
    getQAResault(val){
      for(var i = 0;i<this.qaList.length;i++){
        this.qaList[i].curAnswerText= this.qaList[i].answers[this.qaList[i].curAnswer].title;
        this.qaList[i].productId= this.productId
        if(val===1){
          this.qaList[i].confirmRule= 1
        }
      }
      var params = {
        data: this.qaList
      }
      this.$post("/questionnaire/save", params)
        .then(response => {
          console.log(response.data)
          this.questionnaireData=response.data
        })
        .catch(err => {
          this.$global.alertError();
        })
    },
    getQAData(){
      var params = {
        kind: 1,
        productId:this.productId,
        month:this.month
      }
      this.$get("/questionnaire/query", params)
        .then(response => {
          this.qaList=response.data
          console.log(response)
        })
        .catch(err => {
          this.$global.alertError();
        })
    },
    selectAnswer(item,index){
      if(item.curAnswer<0){
        this.selectNum++
      }
      item.curAnswer=index
      if(this.selectNum>=5){
        this.showQAError=false
      }
      if(item.id===5&&index===1){
        this.showNotice=true
      }
    },
    submitFun(){
      if(this.selectNum<5){
        this.showQAError=true
      }else{
        if(this.qaList[0].curAnswer==3){
          this.showRulePop=true
        }else{
          //保存问卷
          this.getQAResault()
          this.showRulePop=false
          this.showQAError=false
          this.showQAPop=false
          this.isSubmit=true
        }
      }
    },
    confirmRuleFun(val){
      //保存问卷
      this.getQAResault(val)
      this.showRulePop=false
      this.showQAPop=false
      this.isConfirmRules=true
      this.isSubmit=true
    },
    qaListTheLastOne(){
      var theLastIndex = this.qaList.length - 1;
      var priceUnit = ""
      if (this.month < 12) {
        priceUnit = this.month + '月';
        }
        if (this.month === 12) {
          priceUnit =  '年';
        }
        if (this.month === 24) {
          priceUnit =  '2年';
        }
      var split =  this.qaList[theLastIndex].title.split("，")
      this.qaList[theLastIndex].title = split[0] + "，原价" + this.mainOriPrice +  "/" + priceUnit + "”?";
    },
    productAttachTimeUnit(val){
      if (val < 12) {
            return  '/'+ val +'月';
        }
        if (val === 12) {
            return '/年';
        }
        if (val === 24) {
            return '/2年';
        }
    },
    productSentPowerTime(val1,val2){
      if(val2 && val2 > 0){
        return val1 + val2*24*60*60*1000
      }
      return val1;
    }
  },
  components: {
    AppHeader,
    AppFooter,
    Protocol,
    Invoice,
    BindTel
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/scss/order.scss";
.totalLine {
  overflow: hidden;
  color: #666;
}
.totalLine .note {
  font-size: 16px;
  // float: left;
  margin: 0px 0 20px 0px;
}
.hknote {
  font-size: 18px;
  margin: 10px 0 0px 0px;
  background-color: #d07d0057;
  color: #d04500;
  width: 45%;
}
.totalLine .note-r {
  float: right;
  font-size: 16px;
}
.totalLine .note-r p {
  margin-bottom: 10px;
}
.totalLine .note-r p span {
  margin-right: 5px;
}
.totalLine .note-r p:nth-child(1) span {
  float: left;
}
.totalLine .note-r p:nth-child(1) em {
  display: block;
  text-align: right;
}
.totalLine .totalMoney strong {
  font-size: 30px;
  color: #EF3939;
}
.totalLine .totalMoney em {
  font-size: 18px;
  color: #EF3939;
}
.invoice .title + p span {
  margin-right: 20px;
}
.orderWrap .invoice {
  position: relative;
  padding-bottom: 50px;
}
.invoice .modify {
  color: #166fff;
  cursor: pointer;
  font-size: 20px;
  background: rgba(22,111,255,0.05);
  border: 1px solid rgba(22,111,255,0.30);
  border-radius: 2px;
  float: left;
  margin-left: 20px;
  line-height: 42px;
  width: 100px;
  text-align: center;
}
.invoice .confirmBtn {
  position: absolute;
  top: 80px;
  right: 100px;
  background: #166fff;
  border-radius: 4px;
  width: 163px;
  height: 52px;
  line-height: 52px;
  text-align: center;
  font-size: 22px;
  color: #fff;
  display: block;
}
.invoice .confirmBtn:hover {
  background: #1460db;
}
.invoice .title + p {
  padding-left: 35px;
}
.totalLine .voucherText {
  // padding-left: 35px;
}
.totalLine .moreText {
  // float: right;
  text-align:right;
  a{
    font-size: 16px;color:#286DF7;
    &:after{
      content:'';display:inline-block;margin:0 10px;vertical-align:2px;
      width:10px;height:10px;border-bottom:1px solid #999;border-right:1px solid #999;transform:rotate(45deg);
    }
  }
  &.up a:after{
    transform:rotate(225deg);vertical-align:-4px;
  }
}
.invoice .title + p {
  overflow: hidden;
}
.invoice .title + p > strong{
  background: rgba(22,111,255,0.05);
  border: 1px dashed rgba(22,111,255,0.30);
  line-height: 42px;
  padding-left: 20px;
  position: relative;
  overflow: hidden;
  z-index: 1;
  float: left;
  // &:after{
  //   content: '';
  //   position: absolute;
  //   right: -8px;
  //   top: 12px;
  //   background: #fff;
  //   border: 1px dashed rgba(22,111,255,0.30);
  //   width: 15px;
  //   height: 15px;
  //   border-radius: 50%;
  //   z-index: 10;
  // }
}
.discount-select{
  float:none;padding:15px 10px;background:#F8F8F8;border:1px solid #E9E9E9;margin-top:15px;
  div{
    margin:0;
  }
  .discount-text{
    margin:0;
    p{margin-bottom:15px;}
  }
  .select-item{
    margin-right:50px;
  }
}

.qxWarning{
  background:#fff;
  padding:16px 20px 85px;
  font-size:15px;
  color:#222;
  //margin-top:20px;
  border-radius:6px;
  border:1px solid #166FFF;
  position:absolute;
  box-shadow: 0px 6px 10px 0px rgba(114, 114, 114, 0.25);
  left:0;right:0;
  line-height:22px;
  &.qxAlert{
    //border-color:#DE8704;
    //animation:shine 1s linear forwards;
    position:static;
    box-shadow:none;
    border:0;background:#fdf9f2;
    padding:20px 0;
    margin-top:10px;
  }
  &.qxOK{
    //padding-bottom:85px;
    overflow:hidden;
    &:after{
      content:'';position:absolute;right:40px;bottom:10px;background:url(~@/assets/images/icon/icon-agree.png) no-repeat 0 0;background-size:100% auto;width:90px;height:72px;
    }
  }
  .fr{
    float:right;
  }
  h5{
    text-align:center;
    font-size:16px;
    margin-bottom:10px;
  }
  p{
    strong{
      display:block;
      color:#DE8704;text-align:center;font-weight:normal;
    }
  }
  ul{
    margin-top:15px;
    li{
      border-bottom:1px solid #FFF0D9;
      line-height:32px;
      padding:0 20px;
      &.total{
        font-weight:bold;
        color:#D07D00;
      }
    }
  }
  .qx-btns{
    overflow:hidden;
    padding:0 20px;
    margin-top:20px;
    a{
      background:rgba(222, 135, 4, 0.1);
      line-height:30px;
      border-radius:30px;
      color:#DE8704;
      margin-left:20px;
      width:120px;
      text-align:center;
      &.qx-btns-ok{
        background:#DE8704;
        color:#fff;
      }
    }
  }
}

@keyframes shine{
  0%{border-color:#DE8704;}
  25%{border-color:#fdf9f2;}
  50%{border-color:#DE8704;}
  75%{border-color:#fdf9f2;}
  100%{border-color:#DE8704;}
}
.orderInfo>ul.column6 li .liwrap div.child4{
  .qx-discount{
    color:#DE8704;
    margin:0 -20px;
  }
}
.invoice .confirmBtn.disabled{
  opacity:0.5;
}


.pop-win-confirm{
  position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);
  background:#fff;border:2px solid #166EFF;width:400px;color:#222;
  .pop-close{
    position:absolute;right:20px;top:10px;width:30px;height:30px;background:#EF3939;cursor:pointer;
    &:before,&:after{
      content:'';position:absolute;left:50%;top:50%;background:#fff;border-radius:4px;transform:translate(-50%,-50%) rotate(45deg);
    }
    &:before{width:60%;height:2px;}
    &:after{width:2px;height:60%;}
  }
  h6{
    background:#e8effd;line-height:50px;font-size:22px;padding:0 20px;
  }
  p{
    padding:16px;
    font-size:20px;
  }
  .pop-win-btns{
    text-align:center;border-top:1px solid #E3E3E3;margin-top:15px;
    &.flex{
      display: -webkit-flex; display: -ms-flexbox; display: flex;
    }
    a{
      line-height:57px;font-size:20px;color:#222;flex:1;
      &.btn-ok{
        color:#286DF7;border-left:1px solid #E3E3E3;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/order/OrderConfirm.vue